/** The tile of a widget name the registry does not hold — a tile saved by a
 * newer version, or a name the agent made up. Every widget is built since 31B. */
import { WidgetFrame } from "./frame/WidgetFrame";
import styles from "./Unknown.module.css";

export function Unknown({ name }: { name: string }) {
  return (
    <WidgetFrame title={name}>
      <p className={styles.note}>There is no widget called {name}.</p>
    </WidgetFrame>
  );
}
